import { render } from "./ManagementLayout.vue?vue&type=template&id=766f305e"
import script from "./ManagementLayout.vue?vue&type=script&lang=js"
export * from "./ManagementLayout.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sung-hojang/git-projects/blackpay-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__